module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/ja-product4.b8eb9e3c.png";